import * as type from '../../types';

export function getAllTXnAdmin() {
    return {
        type: type.FETCH_GET_ALL_ADMIN_TXNS
    }
}